<template lang="pug">
  .blog-cards-carousel(v-if="item")
    .image-wrap(v-if="item.image")
      img-box(:media-obj='item.image' xs-aspect-key="1x1" draggable="false" @dragstart.native.prevent="")
    .top-text(v-if="item.title && item.description")
      h2.title.mb-5.f-primary.xs-f-small.sm-f.medium.md-f.large.bold.max-at-tweak(v-html="item.title")
      p(v-if="item.description" v-html="item.description")
    .ctas
      button.mr-btn.xs-f-xxsmall.upper(v-if="item.link && item.link.text" @click.prevent="goToLink(item.link)", data-mr-ass="cta-button", tabindex="0") read more
      a.underline.upper.bold(v-if="blogCTA" :href="blogCTA.link.url" @click.prevent="trackEventFor()") {{ blogCTA.text }}
</template>

<script>
  import imgBox from '../imgBox';
  export default {
    name: "BlogCardsCarousel",
    components: {
      imgBox
    },

    props: {
      item: {
        type: Object,
        required: true,
        default() {
          return {};
        }
      },

      blogCTA: {
        type: Object,
        default: () => ({
          text: 'SEE ALL POSTS',
          link: {
            text: 'Madison Reed Blog',
            url: '/blog',
          },
        })
      },
    },
    
    methods: {
      goToLink(link) {
        this.trackMREventAndRedirect("Homepage blog " + link.url + " clicked", link.url);
      },

      trackEventFor() {
        this.trackMREventAndRedirect("Homepage Blog See All Posts clicked - " + this.blogCTA.link.text, this.blogCTA.link.url);
      },
    },
  };
</script>

<style lang="stylus">
.blog-cards-carousel
  background-color ui-color-1
  height 500px
  margin-right 2em
  padding-bottom 3em

  .image-wrap
    height 50%

  .top-text
    display flex
    flex-direction column
    justify-content top 
    height 22%
    margin 1em

  .ctas
    margin 1em
    max-width 50%
    display flex
    flex-direction column
    align-items left
    align-text center
    justify-content left
    
    >button 
      margin-top 2em

    .underline
      margin 1.5em 0

</style>
